var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list-preview" },
    [
      _vm.uniqueLinks.length
        ? [
            _c("scrollbar", { attrs: { type: "macosx" } }, [
              _c(
                "div",
                { staticClass: "viewport" },
                _vm._l(_vm.uniqueLinks, function (link) {
                  return _c("product", {
                    key: link.id,
                    attrs: {
                      data: link,
                      inlist: true,
                      tsize: "t",
                      joined: _vm.limkNum(link),
                    },
                  })
                }),
                1
              ),
            ]),
          ]
        : _c("span", { staticClass: "no-preview" }, [
            _vm._v("\n        empty list\n    "),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }